import { useState } from "react";
import Button from "@mui/material/Button";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import TextField from "@mui/material/TextField";
import { TeamType } from "../../../types/types";
import { Box, Card, CardActions, CardContent, CardHeader, Container, Divider, Grid, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constants";
import { dbCreateReferee, dbUpdateReferee } from "../../../api/api";
import { setReferees, updateReferee } from "../../../features/referees/refereesSlice";
import NotificationService from "../../../components/notification/NotificationService";

interface Props {
}

const CreateReferee = (props: Props) => {
  const dispatch = useAppDispatch();
  const editingReferee = useAppSelector((state) => state.referees.editingReferee);
  const referees = useAppSelector((state) => state.referees.referees);
  const navigate = useNavigate();
  const tournament = useAppSelector((state) => state.tournament.tournament);

  const [refereeName, setRefereeName] = useState(editingReferee?.name ?? "");

  const updateRefereeHandler = () => {

    if (!editingReferee) return;

    dbUpdateReferee(editingReferee.id, refereeName)
      .then(() => {
        dispatch(updateReferee({ ...editingReferee, name: refereeName }));
        navigate(ROUTES.ADMIN_REFEREES);
        NotificationService.showToast({
          severity: "success",
          text: "Dommeren blev opdateret. Kræver refresh for at se ændringerne.",
          duration: 3000,
        });
      })
      .catch((error) => {
        NotificationService.showToast({
          severity: "error",
          text: "Kunne ikke opdatere dommeren.",
          duration: 3000,
        });
        console.error(error);
      });
  };

  const createRefereeHandler = () => {
    dbCreateReferee(refereeName, tournament.id).then((newReferee) => {
      dispatch(setReferees([...referees, newReferee]));
      navigate(ROUTES.ADMIN_REFEREES);
    });
  };

  return (
    <>
      <Container maxWidth={"md"}>
        <Stack spacing={3}>
          <Stack direction="row" justifyContent="flex" spacing={4}>
            <Typography variant="h4">{editingReferee ? "Opdater dommer" : "Opret dommer"}</Typography>
          </Stack>
          <Card>
            <form autoComplete="off" noValidate onSubmit={() => { }}>
              <Card>
                <CardHeader subheader="Udfyld følgende oplysninger:" title={editingReferee ? "Opdater dommer" : "Ny dommer"} />
                <CardContent sx={{ pt: 0 }}>
                  <Box sx={{ m: -1.5 }}>
                    <Grid container>
                      <Grid xs={12} md={6} padding={1} item>
                        <TextField
                          fullWidth
                          label="Navn"
                          name="refereeName"
                          onChange={(e) => setRefereeName(e.target.value)}
                          required
                          value={refereeName}
                        />

                      </Grid>
                    </Grid>
                  </Box>
                </CardContent>
                <Divider />
                <CardActions sx={{ justifyContent: "flex-end" }}>
                  <Button variant="outlined" onClick={() => navigate(ROUTES.ADMIN_REFEREES)}>
                    Fortryd
                  </Button>
                  <Button
                    disabled={!refereeName}
                    variant="contained"
                    onClick={editingReferee ? updateRefereeHandler : createRefereeHandler}
                  >
                    {editingReferee ? "Opdater" : "Opret"}
                  </Button>
                </CardActions>
              </Card>
            </form>
          </Card>
        </Stack>
      </Container>
    </>
  );
};

export default CreateReferee;
